var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "lentisole" } },
    [
      _c(
        "div",
        { staticClass: "toolbar", class: { dark: _vm.darkTheme } },
        [
          _c(
            "v-layout",
            {
              staticClass: "d-flex justify-center align-center",
              class: { "justify-center": _vm.$vuetify.breakpoint.mdAndDown },
            },
            [
              _vm.config.lenti_stile
                ? _c(
                    "div",
                    { staticClass: "misura select-layout" },
                    [
                      _c("v-select", {
                        staticClass: "uppercase",
                        attrs: {
                          "menu-props": {
                            offsetY: true,
                            top: false,
                            maxHeight: "20%",
                          },
                          inputmode: "none",
                          clearable: "",
                          items: _vm.lensCategory,
                          "item-text": "text",
                          "item-value": "id",
                          dense: "",
                          "hide-selected": "",
                          "hide-details": "",
                          label: _vm.$t("message.Categoria"),
                        },
                        model: {
                          value: _vm.tipologia,
                          callback: function ($$v) {
                            _vm.tipologia = $$v
                          },
                          expression: "tipologia",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "align-items": "center",
          },
        },
        [
          _c(
            "v-alert",
            {
              attrs: {
                value: _vm.noTempleAvailable(),
                type: "error",
                dismissible: "",
              },
            },
            [
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "message.Nessuna_lente_corrispondente_per_questa_categoria"
                      )
                    ) +
                    "! "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("ItemsCarousel", {
        attrs: {
          itemsType: _vm.itemsType,
          itemsCarousel: _vm.filteredSunLenses,
          itemsWrap: _vm.config.lentiSole_wrap,
          activeElement: _vm.activeModelCode,
        },
        on: { "item-selected": _vm.setActiveSunLens },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }